class ReadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.limitChars = 500;
    this.contents = this.querySelectorAll('.js-content');
    this.contents.forEach(content => {
      this.readMoreBtn = content.nextElementSibling;
      if(content.textContent.length < this.limitChars){
        this.readMoreBtn.classList.add('hidden');
      } else {
        this.displayText = content.textContent.slice(0,this.limitChars);
        this.moreText = content.textContent.slice(this.limitChars);
        content.innerHTML = `${this.displayText}<span class="dots">...</span><span class="hidden more">${this.moreText}</span>`;
        this.readMoreBtn.addEventListener('click', () => {
          this.post = this.readMoreBtn.parentElement;
          this.post.classList.toggle('hidden-active');
          this.post.querySelector('.dots').classList.toggle('hidden');
          this.post.querySelector('.more').classList.toggle('hidden');
          
        });
      }
    });
  }
}
customElements.define("read-more", ReadMoreButton);